import { CircleDollarSignIcon } from "lucide-react"

import { AppPagination } from "@/components/commons/app-pagination"
import { AppSkeletonTable } from "@/components/commons/app-skeleton-table"
import { DataTable } from "@/components/ui/data-table"
import { useSalesSearchParams, useTransactions } from "@/hooks"

import { salesColumns } from "./columns"
import { TransactionsDownload } from "./download"
export const SalesTable = () => {
  const { params } = useSalesSearchParams()
  const { data: transactions, isFetching } = useTransactions(
    params,
    Boolean(params.refetch),
  )
  const count = transactions?.count || 0
  const pagination = {
    currentPage: params.page,
    total: count,
    totalPages: Math.ceil(count / params.quantity),
  }
  if (isFetching)
    return (
      <AppSkeletonTable
        withHeaderButton
        withAction
        columns={salesColumns.length}
      />
    )
  return params.refetch ? (
    <>
      <DataTable
        showColumnVisibility
        columns={salesColumns}
        data={transactions?.transactions}
        actionChildren={<TransactionsDownload />}
      />
      <AppPagination pagination={pagination} />
    </>
  ) : (
    <div className="mt-4 flex flex-1 flex-col items-center justify-center gap-4">
      <CircleDollarSignIcon size={48} />
      <p>Para visualizar transações de Venda efetue uma busca.</p>
    </div>
  )
}
